import PropTypes from 'prop-types';
// @flow

import React from 'react';

// -- entities
import MenuPartCategory from 'PMT/entities/menu/MenuPartCategory';

// -- views

class CategoryItem extends React.PureComponent {
  static propTypes = {
    category: PropTypes.objectOf(MenuPartCategory).isRequired,

    isSelected: PropTypes.bool.isRequired,

    onSelect: PropTypes.func,

    onDeselect: PropTypes.func,
  };

  onClick = () => {
    this.props.isSelected === true
      ? this.props.onDeselect(this.category)
      : this.props.onSelect(this.category);
  };

  get category(): MenuPartCategory {
    return this.props.category;
  }

  get isSelected(): boolean {
    return this.props.isSelected;
  }

  render() {
    return (
      <div className="category_item pointer" onClick={this.onClick}>
        {this.isSelected && <i className="fa fa-check-square-o" />}
        {!this.isSelected && <i className="fa fa-square-o" />}
        &nbsp;&nbsp;
        {this.category.name}
      </div>
    );
  }
}

export default CategoryItem;



// WEBPACK FOOTER //
// ./scripts/pages/menu/menuPartEdit/SelectItemsModal/components/CategoryItem.js